'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var gifts = exports.gifts = {
  title: 'Gifts',
  why: 'Surprise someone with a course',
  description: 'Choose to give a useful and fun gift. We guarantee a good surprise ;)',
  cta: 'Find courses to give',
  how_it_works: 'How does it work',
  find_title: 'Find the perfect course',
  find_description: 'Think about the other person and how you can help them. Select the topic and the course, free or paid. Click on the “Gift” link',
  wrap_title: 'Prepare the gift',
  wrap_description: 'Personalize the gift. Write a message, we will send it to the person you want at the date and time you choose.',
  notify_title: 'Stay alert',
  notify_description: 'We will alert you when we send the gift. The other person will receive an email with your message and a coupon to gain access to the course.',
  repeat_title: 'Do it again!',
  repeat_description: 'Giving gifts, like helping others, is unlimited. You can give as many courses as you want, to any number of people.'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/en/gifts.js
// module id = 715
// module chunks = 0